const range = (first: number, last: number) => Array.from({ length: last - first }, (_, index) => index + first)

export default range
